import { getOscConfig } from '@twiliointernal/e2-commons-shared-definitions';
import {
  FetchArgs,
  SetFetchArgsParams,
  SetHelpCenterUrlParams,
  SetWiseOwlBaseUrlParams,
} from './definitions/types';

const { helpCenterApiEndpoint, wiseOwlAPIEndpoint } = getOscConfig();

const bodyMethods = ['POST', 'PUT', 'PATCH'];

const setWiseOwlUrl = ({
  fetchArgs,
  isLoggedIn,
  stargateUngatedUserId,
}: SetWiseOwlBaseUrlParams): string => {
  const baseUrl = isLoggedIn
    ? `${wiseOwlAPIEndpoint}/auth/v2`
    : `${wiseOwlAPIEndpoint}/v2`;
  const url = isLoggedIn
    ? `${baseUrl}/${fetchArgs.url}`
    : `${baseUrl}/${fetchArgs.url}?stargate-ungated-user-id=${stargateUngatedUserId}`;

  return url;
};

const setHelpCenterUrl = ({ fetchArgs }: SetHelpCenterUrlParams): string => {
  // Remove undefined from endChat url (https://github.com/twilio-internal/1e2/blob/261fafb1e793c1506dc9ab772ec32190fb2281ac/libs/ui-wise-owl/src/components/wise-owl-live-chat/services/conversations/conversationsService.ts#L155-L168)
  const cleanUrl = fetchArgs.url.replace(/^undefined\/v1\//, '');
  const url = `${helpCenterApiEndpoint}/v1/${cleanUrl}`;

  return url;
};

export const setFetchArgs = ({
  csrf,
  fetchArgs,
  isLoggedIn,
  requestService,
  stargateUngatedUserId,
}: SetFetchArgsParams): FetchArgs => {
  const url =
    requestService === 'wiseOwl'
      ? setWiseOwlUrl({
          fetchArgs,
          isLoggedIn,
          stargateUngatedUserId,
        })
      : setHelpCenterUrl({ fetchArgs });

  const headers = {
    ...fetchArgs.headers,
    'Content-Type': 'application/json',
    'x-twilio-csrf': csrf,
  };
  const additionalBody = isLoggedIn
    ? {}
    : { 'stargate-ungated-user-id': stargateUngatedUserId };

  const baseArgs = {
    ...fetchArgs,
    url,
    headers,
    credentials: 'include',
  };

  const updatedFetchArgs = bodyMethods.includes(fetchArgs.method)
    ? {
        ...baseArgs,
        body: {
          ...fetchArgs.body,
          ...additionalBody,
        },
      }
    : baseArgs;

  return updatedFetchArgs;
};
